import React from 'react';
import styled from 'styled-components';

import W from '../styled/Wrapper';
import H from '../styled/Heading';
import P from '../styled/Paragraph';
import NumbersRichText from './NumbersRichText';

const Wrapper = styled(W)`
  margin-bottom: 45px;

  @media only screen and (max-width: 810px) {
    margin-bottom: 15px;
  }
`;

const HeadingsWrapper = styled.h3`
  display: flex;
  align-items: baseline;
  margin-bottom: 66px;
  border-top: 2px solid ${({ theme }) => theme.colorMain};

  @media only screen and (max-width: 810px) {
    flex-wrap: wrap;
    margin-bottom: 35px;
  }
`;

const HeadingLarge = styled(H)`
  font-size: 180px;
  margin-right: 10px;

  @media only screen and (max-width: 810px) {
    font-size: 54px;
    line-height: 1;
  }
`;

const HeadingSmall = styled(H)`
  @media only screen and (max-width: 810px) {
    font-size: 36px;
    line-height: 1;
  }
`;

const TextWrapper = styled.div`
  display: flex;

  @media only screen and (max-width: 810px) {
    display: block;
  }
`;

const Col = styled(P)`
  max-width: ${({wide}) => wide ? '75%' : '650px'};
  padding-right: 78px;

  @media only screen and (max-width: 810px) {
    max-width: 100%;
    padding-right: 14px;
  }
`;

const Numbers = ({ data }) => {
  return (
    <Wrapper>
      <HeadingsWrapper>
        {
          //   data.largeHeading && (
          //   <HeadingLarge size={1} as="div">
          //     {data.largeHeading}
          //   </HeadingLarge>
          // )
        }

        {
          //   data.smallHeading && (
          //   <HeadingSmall as="div" size={3}>
          //     {data.smallHeading}
          //   </HeadingSmall>
          // )
        }

        {data.heading2 && (
          <NumbersRichText
            content={data.heading2.raw}
            firstParMargin
          />
        )}
      </HeadingsWrapper>

      <TextWrapper>
        {data.textCol1 && <Col wide={!data.textCol2}>{data.textCol1}</Col>}
        {data.textCol2 && <Col>{data.textCol2}</Col>}
      </TextWrapper>
    </Wrapper>
  );
};

export default Numbers;
